//import MemoryCaptureAttraction from './MemoryCaptureCreator/MemoryCaptureAttraction'
import CabanasAttraction from './CabanasCreator/CabanasAttraction'
import BusTicketAttraction from './BusTicketCreator/BusTicketAttraction'
import SpaAttraction from './SpaCreator/SpaAttraction'

const AvailableOnline = () => (
    <>
        <SpaAttraction />
        <BusTicketAttraction />
        {/*TODO: module disabled: MEMORY CAPTURE */}
        {/*<MemoryCaptureAttraction />*/}
        <CabanasAttraction />
    </>
)

export default AvailableOnline
